// Ícono MDI por subtipo de hit. Fuente única para el sidebar de alertas y el
// header del drawer, que antes lo resolvían cada uno por su lado y se
// desincronizaron: ambos usaban `mdi-car-search` para hitLpr, un nombre que NO
// existe en @mdi/font, así que el elemento se renderizaba vacío (0x0) y el
// operador no veía ícono alguno en los hits LPR.
//
// Al agregar un subtipo, verificar que el ícono exista en la versión instalada
// de @mdi/font — hay un test que lo valida contra el CSS del paquete.
import { MC_ALERT_TYPES } from './mc-alert-types'

// Los subtipos de medidas cautelares entran al mismo tab de hits del sidebar,
// así que su ícono se resuelve por este mismo mapa. La definición vive en
// mc-alert-types.js (junto con su label) para no duplicarla.
const MC_ICONS = Object.keys(MC_ALERT_TYPES).reduce((acc, key) => {
  acc[key] = MC_ALERT_TYPES[key].icon
  return acc
}, {})

export const HIT_ICONS = {
  hitLpr: 'mdi-license', // la placa detectada, no la cámara que la leyó
  hitMandamiento: 'mdi-gavel',
  hitRoboVehiculo: 'mdi-car-off',
  iSentry: 'mdi-motion-sensor',
  Acuseek: 'mdi-eye-outline',
  ...MC_ICONS,
}

export const HIT_ICON_FALLBACK = 'mdi-bell-ring'

// `hit` puede ser el MapMonitor del drawer o el alert.data del sidebar: ambos
// llevan typeOfItem/hitType.
export function hitIcon(typeOfItem, hitType) {
  return HIT_ICONS[typeOfItem] || HIT_ICONS[hitType] || HIT_ICON_FALLBACK
}

export default hitIcon
